
import Vue from 'vue'
import VueRouter from 'vue-router'

import { useLogin } from '@/helpers/auth'
import { useConfig } from '@/helpers/config'
import { SITE_EVENT, SiteBus } from '@/components/siteModale/SiteModale.vue'
import routes, { base, names } from './routes'

const BASE_URL = ( process.env.VUE_APP_BASE_URL ) ? process.env.VUE_APP_BASE_URL : ''

let Router = (() => {

    Vue.use(VueRouter)

    const router = new VueRouter({
            mode: 'history',
            base: base,
            routes: routes
        })

    router.beforeEach((to, from, next) => {

        const { isLogged, clientId, siteId } = useLogin()

        /// Si le token n'existe pas, on empêche le chargement de la page.
        /// et on déconnecte de force l'utilisateur
        if ( !isLogged ) {
            window.location = useConfig().LOGOUT_URL
            return false
        }

        /// Si le client ou le site ne sont pas sélectionné, on empêche le chargement de la page.
        /// Dans ce cas de figure, si SiteModale est chargée, la fenêtre de choix s'ouvrira.
        if ( clientId == null || siteId == null ) {
            SiteBus.$emit(SITE_EVENT)
            return false
        }

        next()
    })

    console.log('🛤️ Router Adelya initialisé')
    return router
    
})()

let goTo = ( uri, newTab = false ) => {
    let url = BASE_URL + uri;
    ( newTab ) ?
        window.open(url, '_blank') :
        window.location = url
}

let createUrl = (url, params) => {

    if ( params ) {
        url += ( url.includes('?') ) ? '&' : '?'
        url += Object.keys(params).map(key => key + '=' + params[key]).join('&')
    }

    return url
}


export default Router
export { createUrl, goTo }
export { names as routes }